export default __webpack_public_path__ + "static/media/five.6c1a088b.jpg";